// src/authConfig.ts

import { Configuration, LogLevel } from "@azure/msal-browser";

// MSAL configuration
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID!,
    authority: process.env.REACT_APP_AZURE_AUTHORITY,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Verbose,
    },
  },
};

// Scopes for your custom API only - no Microsoft Graph scopes
export const loginRequest = {
  scopes: [
    process.env.REACT_APP_API_SCOPE ||
      "api://68219f1a-7314-4fcf-ac61-09dd07a3220e/access_as_user",
  ].filter((scope): scope is string => typeof scope === "string"),
  redirectUri: window.location.origin,
};

// Separate request for Microsoft Graph if needed
export const graphRequest = {
  scopes: ["User.Read", "Mail.Read"],
};

// Add here scopes for access token to be used at MS Graph API endpoints.
export const tokenRequest = {
  scopes: [
    process.env.REACT_APP_API_SCOPE ||
      "api://68219f1a-7314-4fcf-ac61-09dd07a3220e/access_as_user",
  ],
};
